export default "__VITE_ASSET__741acb21__"